import { useState } from "react"

import {
  List,
  ListItem,
  Checkbox,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Button
} from "@mui/material"

import { notificationsSettings } from "../../../consts"
import {
  notificationsList,
  notificationsListItem,
  notificationsListButton,
  notificationsSaveButton
} from "./notificationsSettingsStyle"
import s from "./styles.module.scss"

const NotificationsSettings = () => {
  const [checked, setChecked] = useState(
    notificationsSettings.map(({ text }) => text),
  )

  const handleToggle = (value: string) =>
    setChecked((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    )

  return (
    <div className={s.notifications_container}>
      <List sx={notificationsList} disablePadding>
        {notificationsSettings.map((item) => (
          <ListItem key={item.text} sx={notificationsListItem} disablePadding>
            <ListItemButton
              sx={notificationsListButton}
              role={undefined}
              onClick={() => handleToggle(item.text)}
              dense
              disableGutters
            >
              <item.icon />
              <ListItemText
                id={item.text}
                primary={item.text}
                disableTypography
                sx={{
                  margin: 0,
                  fontFamily: "Roboto",
                  fontWeight: 500,
                  fontSize: "14px",
                  span: {
                    fontWeight: 500,
                  },
                }}
              />
              <ListItemIcon>
                <Checkbox
                  sx={{
                    margin: 0,
                    padding: 0,
                    right: 0,
                    color: "var(--Schemes-On-Surface)",
                    "&.Mui-checked": {
                      color: "var(--Schemes-Primary)",
                    },
                  }}
                  edge="start"
                  checked={checked.includes(item.text)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": item.text }}
                />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Button
        variant="text"
        type="submit"
        aria-label="save changes"
        sx={notificationsSaveButton}
        onClick={() => {
          console.log(
            "Настройки уведомлений:",
            checked.join(", ").toLowerCase(),
          )
        }}>
          Применить
      </Button>
    </div>
  )
}
export default NotificationsSettings
